module.exports = __webpack_public_path__ + "static/media/YF43_0.45fcaf5f.jpg";